import * as React from 'react';
import styled from 'styled-components';
import { Button } from '../button/Button';
import { ButtonColor } from '../../enums/common';
import Popup from '../popup/Popup';
import SLink from '../StyledLink/styledLink';
import { VerificationCode } from '../verificationCode/verificationCode';
import addEventKeyUpListenerHelper from '../../helpers/listenerHelper';
import {
  SActionsSection,
  SCodeSection,
  SHelp,
  SMessage,
  SMessageError,
  SVerificationCodeSent,
  SEdiv,
} from './PinCodeStyle';
import { PopupTheme } from '../../enums/common';

// ############################ Imported from Old UI ###########################

// ############################ Styles ###########################
// tslint:disable:variable-name
const SText = styled.p(({ theme }) => ({
  fontSize: theme.font.size.smallMedium,
  fontWeight: theme.font.weight.light,
  color: theme.colors.grayDark,
  marginBottom: theme.spacing.mediumLarger,
}));

const AlertText = styled(SText as any)(({ theme }) => ({
  fontSize: theme.font.size.medium,
  fontWeight: theme.font.weight.bold,
  color: theme.colors.error,
  textAlign: 'center',
}));
const SVerificationCodeSentLayout = styled(SVerificationCodeSent as any)(({ theme }) => ({
  marginBottom: theme.spacing.mediumLarger,
}));
// tslint:enable:variable-name
// ############################ End Styles ###########################

export interface IVerifyState {
  email: string;
  verificationCode: string;
}

export interface IPincodeProps {
  onChange: (value: string | boolean, name: string) => void;
  submit: (verifyState: Partial<IVerifyState>) => void;
  resendFunc: () => void;
  onCloseModal: () => void;
  email?: string;
  verificationCode?: string;
  error?: boolean;
}

export default class PinCodeEmail extends React.Component<IPincodeProps> {
  public state = {
    verificationCode: '',
  };

  public componentDidMount() {
    addEventKeyUpListenerHelper('VerificationCode', this.onVerifiedPinCodeEnterKeyUp);
  }

  private verificationCodeFilled = async (verificationCode: string) => {
    this.setState({ verificationCode });
    await this.props.onChange(verificationCode, 'verificationCode');
  };

  private closeModal = () => {
    this.props.onCloseModal();
    this.props.onChange(false, 'openPincodePopup');
  };

  private handleSubmit = () => {
    this.props.submit({
      email: this.props.email,
      verificationCode: this.state.verificationCode,
    });
  };

  private onVerifiedPinCodeEnterKeyUp = () => {
    if (this.state.verificationCode.length === 4) {
      this.handleSubmit();
    }
  };

  private resendHandler = () => {
    this.setState({ verificationCode: '' }, () => {
      this.props.resendFunc();
    });
  };

  public render() {
    let message = (
      <SMessage data-at="pincodeText1">
        We just sent a 4 digit code to your email address -<strong>{this.props.email || ''}</strong> <br /> Please enter
        it below.
      </SMessage>
    );
    if (this.props.error) {
      message = <SMessageError data-at="pincodeIncorrectCodeText">Incorrect code. Please try again.</SMessageError>;
    }

    return (
      <Popup theme={PopupTheme.success} dataAt="sunbit-popUp" onClose={this.closeModal}>
        <SVerificationCodeSentLayout data-at="verificationCodeHeader">
          We Need to Verify Your Email
        </SVerificationCodeSentLayout>
        <AlertText data-at="verificationEmailDoNoCloseBrowser1">Please don&apos;t close this window</AlertText>
        {message}
        <SCodeSection id="VerificationCode">
          <SEdiv>E</SEdiv>
          <SEdiv>-</SEdiv>
          <VerificationCode
            error={this.props.error}
            value={this.props.verificationCode}
            onFilled={this.verificationCodeFilled}
            autoFocus
          />
        </SCodeSection>
        <SHelp>
          Didn’t get an email?
          <SLink data-at="resendCodeLink" onClick={this.resendHandler}>
            Resend
          </SLink>{' '}
          or
          <SLink data-at="changeEmailLink" onClick={this.closeModal}>
            Change email
          </SLink>
        </SHelp>
        <SActionsSection>
          <Button
            dataAt="verifyBtn"
            color={ButtonColor.light}
            onClick={this.handleSubmit}
            disabled={this.state.verificationCode.length !== 4}
          >
            Verify
          </Button>
        </SActionsSection>
      </Popup>
    );
  }
}
